import { jsx } from "react/jsx-runtime";
import { styled, DialogContent } from "@mui/material";
import { spreadSx } from "../../utils/spreadSx.js";
const StyledDialogContent = styled(
  ({
    sx,
    pt,
    pb,
    paddingTop,
    paddingBottom,
    paddingY,
    ...props
  }) => /* @__PURE__ */ jsx(
    DialogContent,
    {
      ...props,
      sx: [
        (t) => ({
          paddingLeft: {
            xs: t.sizes.common.sm,
            sm: t.sizes.common.md
          },
          paddingRight: {
            xs: t.sizes.common.sm,
            sm: t.sizes.common.md
          },
          "&.MuiDialogContent-root": {
            paddingTop: pt ?? paddingTop ?? paddingY ?? t.sizes.common.md,
            paddingBottom: pb ?? paddingBottom ?? paddingY ?? t.sizes.common.md
          }
        }),
        ...spreadSx(sx)
      ]
    }
  )
)(() => ({
  fontSize: "14px",
  lineHeight: "24px",
  fontWeight: 400,
  overflowY: "initial",
  backgroundColor: "#fff"
}));
StyledDialogContent.displayName = "DialogContent";
export {
  StyledDialogContent
};
//# sourceMappingURL=DialogContent.js.map
